import {
  GET_REGISTRATIONS,
  GET_REGISTRATIONS_FAIL,
  GET_REGISTRATIONS_SUCCESS,
  ADD_NEW_REGISTRATION,
  ADD_REGISTRATION_SUCCESS,
  ADD_REGISTRATION_FAIL,
  UPDATE_REGISTRATION,
  UPDATE_REGISTRATION_SUCCESS,
  UPDATE_REGISTRATION_FAIL,
  DELETE_REGISTRATION,
  DELETE_REGISTRATION_SUCCESS,
  DELETE_REGISTRATION_FAIL,
  
} from "./actionTypes";

export const getRegistrations = () => ({
  type: GET_REGISTRATIONS,
})

export const getRegistrationsSuccess = registrations => ({
  type: GET_REGISTRATIONS_SUCCESS,
  payload: registrations,
})

export const getRegistrationsFail = error => ({
  type: GET_REGISTRATIONS_FAIL,
  payload: error,
})

export const addNewRegistration = data => ({
  type: ADD_NEW_REGISTRATION,
  payload: data,
})

export const addRegistrationSuccess = registration => ({
  type: ADD_REGISTRATION_SUCCESS,
  payload: registration,
})

export const addRegistrationFail = error => ({
  type: ADD_REGISTRATION_FAIL,
  payload: error,
})

export const updateRegistration = registration => ({
  type: UPDATE_REGISTRATION,
  payload: registration,
})

export const updateRegistrationSuccess = registration => ({
  type: UPDATE_REGISTRATION_SUCCESS,
  payload: registration,
})

export const updateRegistrationFail = error => ({
  type: UPDATE_REGISTRATION_FAIL,
  payload: error,
})

export const deleteRegistration = data => ({
  type: DELETE_REGISTRATION,
  payload: data,
})

export const deleteRegistrationSuccess = data => ({
  type: DELETE_REGISTRATION_SUCCESS,
  payload: data,
})

export const deleteRegistrationFail = error => ({
  type: DELETE_REGISTRATION_FAIL,
  payload: error,
})

/*

export const resetRegistrationLastActionSuccess = () => ({
    type: "RESET_LAST_ACTION_SUCCESS"
});
*/
